import { ComponentProps, ComponentType } from 'react';
import i18n from 'i18next';
import { withTranslation } from 'react-i18next';
import isAuthorDomain, { AuthorDomain } from '../utils/is-author-domain';
import lastVisitedWorld from '../utils/last-visited-world';
import getWorldFromUrl from '../utils/url/get-world-from-url';
import { FALLBACK_WORLD } from './constants';

const detectWorld = (): string => {
    const ad: AuthorDomain = isAuthorDomain();

    // @ts-ignore
    return ad?.world || getWorldFromUrl() || lastVisitedWorld.get() || FALLBACK_WORLD;
};

export const namespaceExists = (namespace: string) => {
    if (i18n.reportNamespaces) {
        // @ts-ignore
        const { usedNamespaces } = i18n.reportNamespaces;

        return usedNamespaces[namespace];
    }
};

function loadNamespace(world: string, namespace: string): Promise<void> {
    if (namespace && namespaceExists(namespace)) {return Promise.resolve();}

    return import(`../languages/${world}/${namespace}.json`).then(({ default: data }) => {
        if (i18n.addResourceBundle) {
            i18n.addResourceBundle(world, namespace, data);
        }
    })
        .catch((err) => {
            console.error(`Failed to load namespace "${namespace}"`, err);
        });
}

export const world: string = detectWorld();

// eslint-disable-next-line func-names
const translation = (ns: string | string[]) => {
    const namespaces = Array.isArray(ns) ? ns : [ns];

    namespaces.forEach((namespace) => {
        if (namespace && !namespaceExists(namespace)) {
            import(`../languages/${world}/${namespace}.json`).then(({ default: data }) => {
                if (i18n.addResourceBundle) {
                    i18n.addResourceBundle(world, namespace, data);
                }
            });
        }
    });

    return <T extends ComponentType<ComponentProps<T>>>(WrappedComponent: T) =>
        withTranslation(namespaces)(WrappedComponent);

    // @ts-ignore
    // return function (WrappedComponent) {
    //     const Translated = withTranslation(namespaces)(WrappedComponent);

        // // @ts-ignore
        // return (props) => {
        //     const [ready, setReady] = useState(false);
        //
        //     useEffect(() => {
        //         Promise.all(namespaces.map((ns) => loadNamespace(world, ns))).then(() =>
        //             queueMicrotask(() => setReady(true))
        //         );
        //     }, []);
        //
        //     if (!ready) {
        //         return null;
        //     }
        //
        //     return <Translated {...(props)} />;
        // };
    // };
};

export default translation;
